import { render, staticRenderFns } from "./InputPercentage.vue?vue&type=template&id=b02c4e3e&"
import script from "./InputPercentage.vue?vue&type=script&lang=js&"
export * from "./InputPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports